function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#0B6FA1",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M9.063 16.788l3.124 1.4L10.2 19.45c-.425.25-.8.4-1.2.4-1.037 0-1.9-.85-1.95-1.863l2.013-1.2zm4.4-3.7l1.875.825c.7.312.912.687.912 1.15 0 .262-.15.524-.363.712l-3.15-1.4.538-.3c.45-.25.6-.4.6-.563 0-.175-.1-.287-.412-.425zM8.9 11.575l3.162 1.4-.787.45c-.213.137-.363.25-.363.412 0 .188.213.338.488.463l-1.5-.663c-.662-.3-1.3-.55-1.3-1.287 0-.387.113-.575.3-.775zM16.275 7c.5.287.988.85.988 1.613 0 .812-.413 1.375-1.126 1.787l-.375.213-3.175-1.4L16.276 7zm-3.262-3c.5.287.975.85.975 1.612 0 .825-.413 1.363-1.113 1.788l-1.537.925c-.138.088-.313.213-.313.425 0 .238.35.412.662.563l-1.912-.85c-.563-.25-1.125-.525-1.125-1.213a1.3 1.3 0 0 1 .213-.713L13.013 4z",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M8.912 11.575c-.187.2-.3.4-.3.775 0 .738.626.988 1.3 1.287l5.563 2.45c.963.413 1.85 1.125 1.85 2.35 0 .663-.25 1.263-.525 1.563-.8-.613-1.65-1.025-2.675-1.5L9.35 16.387c-1.2-.537-2-1.25-2-2.45 0-1.162.563-1.724 1.3-2.2l.262-.162zm-.05-5.05c-.137.2-.212.425-.212.712 0 .675.563.963 1.125 1.213L15.55 11c1.05.463 1.9 1.162 1.9 2.45 0 1.013-.462 1.638-1.212 2.1l-.35.225c.212-.188.362-.45.362-.713 0-.462-.212-.837-.912-1.15L9.4 11.287c-1.2-.525-1.95-1.212-1.95-2.412 0-1.1.55-1.813 1.413-2.35z"
}));

var SvgIcSc = function SvgIcSc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_sc.22f52253.svg";
export { ForwardRef as ReactComponent };